import { RestaurantAccesses } from '~/lib/accesses/RestaurantAccesses.frag'
import { PARKING_LABEL } from '~/lib/constants/constants'
import { isEmpty } from '~/lib/empty'
import { getFragmentData } from '~/lib/graphql'
import type { FragmentType } from '~/lib/graphql'
import { useIsPC } from '~/lib/ua'
import { css } from '~/styled-system/css'
import { Collapsible } from '~/ui/Collapsible'

type Props = {
  restaurant: FragmentType<typeof RestaurantAccesses>
}

export function Access(props: Props) {
  const isPc = useIsPC()
  const Access = isPc ? PcAccess : SdAccess

  return <Access {...props} />
}

function SdAccess({ restaurant }: Props) {
  const { accesses, parking } = getFragmentData(RestaurantAccesses, restaurant)

  return (
    <Collapsible
      color="neutral"
      header={<h3 className={css({ fontWeight: 'bold' })}>アクセス情報</h3>}
    >
      {!isEmpty(accesses) && (
        <div className={css({ spaceY: '1', fontSize: 'sm' })}>
          {accesses.map((access, index) => {
            if (access.__typename === 'RestaurantAccessTrain') {
              return (
                <div key={index}>
                  {access.line}線　{access.station}駅　{access.note}
                </div>
              )
            }
            if (access.__typename === 'RestaurantAccessCar') {
              return (
                <div key={index}>
                  <span className={css({ whiteSpace: 'pre-wrap' })}>{access.note}</span>
                </div>
              )
            }
          })}
        </div>
      )}
      <div className={css({ spaceY: '1', fontSize: 'sm', mt: '4' })}>
        <h4 className={css({ fontWeight: 'bold' })}>駐車場</h4>
        <div>{PARKING_LABEL[parking.availability]}</div>
        {!isEmpty(parking.note) && (
          <div className={css({ whiteSpace: 'pre-wrap', wordBreak: 'break-all' })}>
            {parking.note}
          </div>
        )}
      </div>
    </Collapsible>
  )
}

function PcAccess({ restaurant }: Props) {
  const { accesses, parking } = getFragmentData(RestaurantAccesses, restaurant)

  return (
    <div>
      {!isEmpty(accesses) && (
        <>
          <h3 className={css({ fontWeight: 'bold', fontSize: '2xl' })}>アクセス情報</h3>
          <div className={css({ spaceY: '2', fontSize: 'md', mt: '3' })}>
            {accesses.map((access, index) => {
              if (access.__typename === 'RestaurantAccessTrain') {
                return (
                  <div key={index}>
                    {access.line}線　{access.station}駅　{access.note}
                  </div>
                )
              }
              if (access.__typename === 'RestaurantAccessCar') {
                return (
                  <div key={index}>
                    <span className={css({ whiteSpace: 'pre-wrap' })}>{access.note}</span>
                  </div>
                )
              }
            })}
          </div>
        </>
      )}
      <h4 className={css({ fontWeight: 'bold', fontSize: 'lg', mt: '5' })}>駐車場</h4>
      <div className={css({ spaceY: '2', fontSize: 'md', mt: '2' })}>
        <div>{PARKING_LABEL[parking.availability]}</div>
        {!isEmpty(parking.note) && (
          <div className={css({ whiteSpace: 'pre-wrap', wordBreak: 'break-all' })}>
            {parking.note}
          </div>
        )}
      </div>
    </div>
  )
}
